import React from 'react';
import { Switch } from '@mui/material';
import './switchInput.scss';

export const SwitchInput = ({
    id,
    onChange,
    checked,
    name,
    disabled = false
}) => {
    return (
        <div className='switch-input-container'>
            <Switch
                id={id}
                name={name}
                onChange={onChange}
                defaultChecked={checked}
                className='switch-input'
                disabled={disabled}
                checked={checked}
            />
        </div>
    )
}